import { createFileRoute } from '@tanstack/react-router';
import BolSignatureGate from '@/components/bol-signature-gate';
import FinalDeliveryPage from '@/features/final-delivery';

export const Route = createFileRoute('/_protected/final-delivery/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <BolSignatureGate>
      <FinalDeliveryPage />
    </BolSignatureGate>
  );
}
